import classnames from 'classnames'
import Image from 'next/image'
import React, { PropsWithChildren } from 'react'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { FadeInWhenVisible } from '../FadeInWhenVisible'
import pageBannerStyles from './pageBanner.module.scss'

type TopBannerMaskProps = {
    className: string
    src: string
    mobileSrc?: string
}

export const TopBannerMask:React.FC<PropsWithChildren<TopBannerMaskProps>> = ({ className, src, mobileSrc }) => {
  const isMobile = useMediaQuery('(max-width: 767px)')

  return (
    <FadeInWhenVisible
      animation="easyFadeInStill"
      transition={{ delay: 0.3, duration: 0.5 }}
      everyVisible={true}
      exitAnimation={{ opacity: 0.5, y: 20 }}
    >
      <div className={classnames(pageBannerStyles.topMask, className)}  >
        {isMobile ? (
          <Image
            src={mobileSrc || src}
            width={768}
            height={608}
          />
        ) : (
          <Image
            src={src}
            width={3840}
            height={1476}
          />
        )}

      </div>
    </FadeInWhenVisible>
  )
}

